/**
 * The check-email illustration: an email appears, a finger taps its blue
 * "Увійти" button, a green tick shows. Tells people to press the button in
 * the email rather than type the code. Loops every 4.8 s; with animations
 * turned off in the system it plays once and stops on finger + tick.
 * Keyframes live in globals.css (email-tap-*).
 */
export default function EmailTapAnimation({ label }: { label: string }) {
  return (
    <svg className="email-tap mx-auto block h-[150px] w-[192px] max-w-full overflow-visible" viewBox="0 0 220 172" role="img" aria-label={label}>
      <defs>
        {/* pointing hand, back of the hand towards the viewer, fingertip at (124, 86) */}
        <g id="email-tap-hand">
          <rect x="119" y="86" width="10" height="36" rx="5" />
          <rect x="128.5" y="106" width="8.5" height="20" rx="4.25" />
          <rect x="136.5" y="108" width="8.5" height="18" rx="4.25" />
          <rect x="144.5" y="111" width="7.5" height="15" rx="3.75" />
          <rect x="108" y="112" width="10" height="22" rx="5" transform="rotate(-38 113 123)" />
          <rect x="116" y="114" width="36" height="28" rx="10" />
        </g>
      </defs>
      <g className="email-tap-letter">
        <rect x="20" y="6" width="180" height="118" rx="10" fill="#ffffff" stroke="#e5e7eb" strokeWidth="1.5" />
        <rect x="36" y="20" width="44" height="8" rx="4" fill="#2563eb" />
        <rect x="36" y="38" width="148" height="6" rx="3" fill="#e5e7eb" />
        <rect x="36" y="50" width="120" height="6" rx="3" fill="#e5e7eb" />
        <rect className="email-tap-ring" x="58" y="70" width="104" height="34" rx="8" fill="none" stroke="#2563eb" strokeWidth="2" />
        <g className="email-tap-btn">
          <rect x="58" y="70" width="104" height="34" rx="8" fill="#2563eb" />
          <text x="110" y="91.5" textAnchor="middle" fill="#ffffff" fontSize="13" fontWeight="600" fontFamily="inherit">Увійти</text>
        </g>
        <g className="email-tap-ok">
          <circle cx="190" cy="16" r="13" fill="#16a34a" />
          <path d="M184 16.5l4 4 8-8.5" fill="none" stroke="#ffffff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
        </g>
      </g>
      <g className="email-tap-hand">
        {/* outline drawn once under the fill, so the hand reads as one shape */}
        <use href="#email-tap-hand" fill="#d9a27c" stroke="#d9a27c" strokeWidth="2.4" strokeLinejoin="round" />
        <use href="#email-tap-hand" fill="#f3c9a8" />
        <rect x="121" y="88" width="6" height="7" rx="3" fill="#fbe3d1" />
        <path d="M129 117.5h22" stroke="#d9a27c" strokeWidth="1" strokeLinecap="round" opacity="0.55" />
        <rect x="115" y="139" width="40" height="16" rx="3" fill="#64748b" />
      </g>
    </svg>
  )
}
